export enum PermissionControlName {
  Number = 'number'
}
